import { render, staticRenderFns } from "./addFounds.vue?vue&type=template&id=6e54071e&scoped=true"
import script from "./addFounds.vue?vue&type=script&lang=js"
export * from "./addFounds.vue?vue&type=script&lang=js"
import style0 from "./addFounds.vue?vue&type=style&index=0&id=6e54071e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54071e",
  null
  
)

export default component.exports